// extracted by mini-css-extract-plugin
module.exports = {"tagWrapper":"tag_tagWrapper__3C4RX","invert":"tag_invert__2Ug0z","tagLabel":"tag_tagLabel__N2_wi","tagIcon":"tag_tagIcon__1CWM-"};